/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
// import {useLocation} from "react-router";
import { NavLink, useLocation }  from "react-router-dom";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl, checkIsActive} from "../../../../_helpers";

export function CustomerAsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
        ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
        : "";
  };

  return (
      <>
        {/* begin::Menu Nav */}
        <ul className={`menu-nav ${layoutProps.ulClasses}`}>
          <li
              className={`menu-item ${getMenuItemActive("/customer/dashboard", false)}`}
              aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/customer/dashboard">
                        <span className="svg-icon menu-icon">
                          <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
                        </span>
              <span className="menu-text">میز کار</span>
            </NavLink>
          </li>

          <li
              className={`menu-item ${getMenuItemActive("/customer/orders", false)}`}
              aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/customer/orders">
                    <span className="svg-icon menu-icon">
                      <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart1.svg")}/>
                    </span>
              <span className="menu-text">سفارشات</span>
            </NavLink>
          </li>

          <li
              className={`menu-item ${getMenuItemActive("/customer/baskets", false)}`}
              aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/customer/baskets">
                        <span className="svg-icon menu-icon">
                          <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag1.svg")}/>
                        </span>
              <span className="menu-text">سبد‌‌های خرید</span>
            </NavLink>
          </li>

            <li
                className={`menu-item ${getMenuItemActive("/customer/products", false)}`}
                aria-haspopup="true"
            >
                <NavLink className="menu-link" to="/customer/products">
                    <span className="svg-icon menu-icon">
                      <SVG src={toAbsoluteUrl("/media/svg/icons/Clothes/Hanger.svg")}/>
                    </span>
                    <span className="menu-text">محصولات</span>
                </NavLink>
            </li>



        </ul>
        {/* end::Menu Nav */}
      </>
  );
}
